import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";

const WA = (modalidad) =>
  `https://wa.me/34678783000?text=${encodeURIComponent(`Hola, me gustaría reservar la modalidad: ${modalidad}.`)}`;

const MODALIDADES = [
  {
    id: "aguardo-jabali", n: "01", name: "Aguardo de Jabalí", tag: "Paciencia, estrategia y la magia de la noche.",
    text: [
      "El aguardo es una de las modalidades de caza más tradicionales y emocionantes, donde la paciencia y la estrategia son clave. Esta técnica consiste en esperar al animal en un punto concreto, previamente estudiado, aprovechando su rutina y comportamiento natural.",
      "En Cinegética Ruta del Agua de Guillena organizamos aguardos en entornos privilegiados, seleccionando los mejores puntos y horarios para garantizar una experiencia inolvidable. Nuestros aguardos son ideales para cazadores que disfrutan de la tranquilidad y la adrenalina de ver cómo la naturaleza sigue su curso, mientras esperan el momento perfecto para realizar un lance ético y seguro.",
      "Descubre con nosotros la esencia de la caza en estado puro y vive la magia de la noche o el amanecer en nuestras fincas.",
    ],
  },
  {
    id: "conejos", n: "02", name: "Conejos", tag: "Clásico, dinámico y muy arraigado en la cultura cinegética.",
    text: [
      "La caza del conejo es una modalidad clásica y muy arraigada en la cultura cinegética. Su versatilidad permite practicarla tanto al salto, con perro, como en mano o al rececho, adaptándose al estilo de cada cazador.",
      "Organizamos jornadas de caza menor de conejos en fincas con abundancia de vegetación baja, zarzales y zonas de monte, donde este animal encuentra su hábitat natural. La rapidez y astucia del conejo ponen a prueba la habilidad del cazador y la destreza de los perros.",
      "Si buscas una jornada de caza activa y emocionante, donde tradición y deporte van de la mano, la caza de conejos es la opción perfecta para disfrutar de la naturaleza y del compañerismo cinegético.",
    ],
  },
  {
    id: "media-veda", n: "03", name: "Media Veda (Paloma Torcaz)", tag: "Movimientos migratorios, rapidez y precisión.",
    text: [
      "La caza de palomas torcaces en media veda es una de las modalidades más emocionantes y técnicas dentro de la caza menor. Durante la media veda, las palomas realizan sus movimientos migratorios y aprovechan las zonas de cultivo y monte bajo, lo que las convierte en un auténtico reto para el cazador.",
      "Organizamos aguardos de palomas en entornos estratégicos donde estas aves encuentran alimento y descanso. Nuestros cazadores están preparados para ofrecer jornadas intensas y seguras, aprovechando el paso natural de las torcaces al amanecer y al atardecer.",
      "Si buscas una modalidad donde la rapidez, la precisión y el conocimiento del entorno sean clave, la media veda es tu oportunidad para disfrutar de una caza menor de alta calidad.",
    ],
  },
  {
    id: "perdiz-reclamo", n: "04", name: "Perdiz con Reclamo", tag: "La modalidad más tradicional de la caza menor andaluza.",
    text: [
      "La modalidad con reclamo es una de las más tradicionales y emocionantes de la caza menor, donde la paciencia y la estrategia son fundamentales. Esta técnica milenaria se basa en el uso de un macho de perdiz (el reclamo) que, con su canto, atrae a las perdices silvestres al puesto del cazador.",
      "Organizamos jornadas de caza con reclamo en escenarios seleccionados, donde el silencio y la conexión con el entorno hacen de cada día de caza una experiencia única. Esta modalidad requiere conocimiento profundo del comportamiento de la perdiz y ofrece al cazador momentos intensos de emoción y tradición.",
      "Vive con nosotros la esencia pura de la caza menor, respetando la ética cinegética y disfrutando de la belleza del campo andaluz.",
    ],
  },
  {
    id: "zorzales", n: "05", name: "Zorzales", tag: "Vuelo veloz, destreza y rapidez del cazador.",
    text: [
      "La caza de zorzales es una de las modalidades más populares y tradicionales entre los aficionados a la menor. Se trata de una caza dinámica, en la que la destreza y la rapidez son esenciales para aprovechar el vuelo veloz y esquivo de estas pequeñas aves.",
      "Organizamos jornadas de caza de zorzales en escenarios naturales privilegiados, donde estos pájaros migratorios encuentran refugio durante la temporada. Nuestro equipo selecciona cuidadosamente las mejores ubicaciones y días, garantizando un aprovechamiento sostenible y una experiencia memorable para cada cazador.",
      "Disfruta del auténtico sabor de la caza menor, rodeado de naturaleza y en compañía de otros apasionados de la cinegética.",
    ],
  },
  {
    id: "caza-con-arco", n: "06", name: "Caza con Arco", tag: "Una práctica milenaria que gana popularidad en Europa.",
    text: [
      "En Cinegética Ruta del Agua de Guillena ofrecemos cazar con arco disponiendo de zonas habilitadas para ello.",
      "La caza con arco es una práctica que está ganando popularidad en Europa, aunque no todos los países tienen la misma regulación al respecto. En España la caza con arco está permitida y cuenta con una normativa específica.",
      "Requisitos generales: licencia de caza válida en el país donde se vaya a cazar; en algunos casos un permiso especial para uso de arco en caza; y seguro de responsabilidad civil obligatorio que cubra posibles daños a terceros durante la actividad.",
    ],
  },
  {
    id: "perdiz-faisan-al-salto", n: "07", name: "Perdiz o Faisán al Salto", tag: "Caza sembrada de la mayor calidad disponible.",
    text: [
      "La caza de la perdiz salvaje (caza al salto sembrada) cada vez es más complicada debido a que, desgraciadamente para los cazadores, cada vez escasea más. Por eso seleccionamos perdiz y faisán de granja de mayor calidad y fuerza, criados por pequeños productores, para que la experiencia en los lances sea lo más parecida posible a la caza salvaje.",
      "Las jornadas cinegéticas de caza al salto sembrada se realizan con perdices y/o faisanes. El monte bajo y las suaves colinas proporcionan protección a la caza y multitud de asomadas y lances al cazador.",
      "Se organizan para grupos entre 4 y 10 cazadores. Periodo hábil: del 15 de septiembre al 1 de abril.",
    ],
  },
  {
    id: "suelta-perdiz-codorniz-faisan", n: "08", name: "Suelta de Perdiz, Codorniz y Faisán", tag: "Sueltas a medida para grupos de 8 a 20 personas.",
    text: [
      "Gestionamos sueltas de perdices, faisán y codorniz en escenario de caza para grupos desde 8 a 20 personas, ajustando precios para el disfrute entre amigos.",
      "También ofrecemos siembra de codorniz para el disfrute con perro de muestra: una manera ideal de iniciarse o de aprovechar al máximo la temporada con compañeros y perros bien adiestrados.",
    ],
  },
];

const fadeUp = {
  initial: { opacity: 0, y: 30 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-60px" },
  transition: { duration: 0.7, ease: "easeOut" },
};

export default function Modalidades() {
  return (
    <div data-testid="modalidades-page">
      {/* INTRO */}
      <section className="max-w-7xl mx-auto px-5 lg:px-8 pt-16 lg:pt-24 pb-12">
        <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
          <p className="overline-gold mb-4">Modalidades de caza</p>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl text-white font-light tracking-tight">
            Todas las formas <span className="text-gold italic">de la caza</span>
          </h1>
          <p className="mt-5 text-white/60 font-light max-w-2xl">
            En Dehesa El Chaparral · Finca Los Perales y en nuestras demás fincas encontrarás una variedad de
            modalidades cuidadosamente seleccionadas. Descubre cada una y reserva hoy mismo la tuya.
          </p>
        </motion.div>
        <motion.div {...fadeUp} className="mt-10 flex flex-wrap gap-3" data-testid="modalidades-nav">
          {MODALIDADES.map((m) => (
            <a key={m.id} href={`#${m.id}`}
              className="px-4 py-2 border border-white/15 text-white/60 hover:text-gold hover:border-gold/50 text-[11px] uppercase tracking-[0.15em] font-semibold transition-colors duration-200"
              data-testid={`modnav-${m.id}`}>
              {m.name}
            </a>
          ))}
        </motion.div>
      </section>

      {/* MODALIDADES */}
      <section className="max-w-7xl mx-auto px-5 lg:px-8 pb-8 space-y-6">
        {MODALIDADES.map((m, i) => (
          <motion.article key={m.id} id={m.id} {...fadeUp} transition={{ ...fadeUp.transition, delay: 0.05 }}
            className="card-dark p-7 lg:p-12 scroll-mt-24" data-testid={`modalidad-${m.id}`}>
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-8">
              <div className="lg:col-span-4">
                <p className="overline-gold !text-[10px]">Modalidad {m.n}</p>
                <h2 className="mt-2 text-3xl lg:text-4xl text-white font-light">{m.name}</h2>
                <p className="mt-3 text-sand text-sm italic font-light">{m.tag}</p>
              </div>
              <div className="lg:col-span-8">
                {m.text.map((p, j) => (
                  <p key={j} className="text-white/65 font-light leading-relaxed mt-4 first:mt-0">{p}</p>
                ))}
                <a href={WA(m.name)} target="_blank" rel="noopener noreferrer" className="btn-gold mt-7" data-testid={`modalidad-reservar-${m.id}`}>
                  <MessageCircle size={15} /> Reservar esta modalidad
                </a>
              </div>
            </div>
          </motion.article>
        ))}
      </section>

      {/* CTA FINAL */}
      <section className="border-t border-white/5 bg-[#0D0D0D]">
        <div className="max-w-7xl mx-auto px-5 lg:px-8 py-20 text-center">
          <motion.div {...fadeUp}>
            <h2 className="text-3xl lg:text-4xl text-white font-light">¿Tienes en mente una <span className="text-gold italic">modalidad concreta</span>?</h2>
            <p className="mt-4 text-white/55 font-light max-w-xl mx-auto">
              Cuéntanos tu plan y te diseñamos una jornada a medida en alguna de nuestras 4 fincas.
            </p>
            <div className="mt-8 flex flex-col sm:flex-row gap-4 justify-center">
              <a href={WA("una jornada a medida")} target="_blank" rel="noopener noreferrer" className="btn-gold-solid" data-testid="modalidades-cta-reservar">
                <MessageCircle size={16} /> Reservar una Jornada
              </a>
              <a href="tel:+34678783000" className="btn-ghost-light" data-testid="modalidades-cta-info">Pedir Información</a>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
}
